import { memo, useEffect, useMemo, useRef, useState } from "react";
import ModalWrapper from "js/Component/ModalWrapper";
import { fetchOrganizationDevices, fetchPolicyGroups } from "js/Api";
import { updateFormDetails, updateFormImage } from "js/Api/forms";
import SendToModal from "js/Component/SendToModal";
import { DEVICES, EVERY_ONE, FormAnnouncementsList, POLICY_GROUP, } from "js/Constants/common";
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import AnnouncementModal from "./AnnouncementModal";
import deviceProfile from "images/device.png";
import moment from 'moment';
import { hasValue } from "../../helpers/common_functions";

const Settings = (props) => {
    const { org, formDetailsObj, refetchFormDetails, isTemplate = false, formDirty_Settings, setformDirty_Settings, handleTabClick } = props;

    const [errors, setErrors] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [displayTitleText, setDisplayTitleText] = useState("");
    const [FinishingTitleText, setFinishingTitleText] = useState("");
    const [displayImageURL, setDisplayImageURL] = useState(deviceProfile);
    const [displayImageURL_finish, setDisplayImageURL_finish] = useState(deviceProfile);
    const [displaySelectedFile, setDisplaySelectedFile] = useState(null);
    const [displaySelectedFile_finish, setDisplaySelectedFile_finish] = useState(null);
    const [allowPublish, setallowPublish] = useState(false);

    // Send to states (common for both form and template)
    const [itemPicker, setItemPicker] = useState(false);
    const [sendTo, setSendTo] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectAll, setSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [groups, setGroups] = useState([]);
    const [devices, setDevices] = useState([]);
    const [isAnnouncementConfirmModal, setIsAnnouncementConfirmModal] = useState(false);
    const [formStatus, setFormStatus] = useState();

    // Regular form states
    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();

    // Template specific states
    const [templateType, setTemplateType] = useState("recurring");
    const [selectedHour, setSelectedHour] = useState(); // 9 AM default
    const [selectedMinute, setSelectedMinute] = useState(); // 00 minutes default
    const [selectedPeriod, setSelectedPeriod] = useState(); // AM/PM
    const [duration, setDuration] = useState({ days: 0, hours: 1 });
    const [activeDays, setActiveDays] = useState([]);
    const [isLoadingModalData, setIsLoadingModalData] = useState(false);
    const [openUnPublishpopup, setopenUnPublishpopup] = useState(false);

    const fileInputRef = useRef(null);
    const fileInputRef_finish = useRef(null);

    // Template options
    const templateOptions = [
        { value: "recurring", label: "On a recurring schedule" },
        { value: "worker_check_in", label: "When someone signs in using Worker Check-in" }
    ];

    // Time options
    const hours = Array.from({ length: 12 }, (_, i) => i + 1); // 1-12
    const minutes = Array.from({ length: 60 }, (_, i) => i); // 0-59
    const periods = ["AM", "PM"];

    // Days of week (Monday = 1, Sunday = 0)
    const daysOfWeek = [
        { id: 1, name: "Monday", short: "Mon" },
        { id: 2, name: "Tuesday", short: "Tue" },
        { id: 3, name: "Wednesday", short: "Wed" },
        { id: 4, name: "Thursday", short: "Thu" },
        { id: 5, name: "Friday", short: "Fri" },
        { id: 6, name: "Saturday", short: "Sat" },
        { id: 0, name: "Sunday", short: "Sun" },
    ];

    const filteredItems = useMemo(() => {
        if (sendTo?.id === POLICY_GROUP.id) {
            return searchQuery?.length > 0
                ? groups?.filter((group) =>
                    group?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
                ) || []
                : groups || [];
        } else if (sendTo?.id === DEVICES?.id) {
            return searchQuery?.length > 0
                ? devices?.filter((device) =>
                    device?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
                ) || []
                : devices || [];
        }
    }, [sendTo, groups, devices, searchQuery]);

    const displaySelectedItems = useMemo(() => {
        if (sendTo?.id === POLICY_GROUP.id) {
            return groups
                ?.filter((item) => selectedItems.includes(item.id))
                .map((item) => item.name)
                .join(", ");
        } else if (sendTo?.id === DEVICES?.id) {
            return devices
                ?.filter((item) => selectedItems.includes(item.id))
                .map((item) => item.name)
                .join(", ");
        } else {
            return "";
        }
    }, [devices, selectedItems, sendTo, groups]);

    // Load data from formDetailsObj
    useEffect(() => {
        // Common data loading
        if (formDetailsObj?.description) {
            setDisplayTitleText(formDetailsObj.description);
        }

        if (formDetailsObj?.finishingDesc) {
            setFinishingTitleText(formDetailsObj.finishingDesc);
        }

        if (formDetailsObj?.imageURL) {
            setDisplayImageURL(formDetailsObj.imageURL);
        }

        if (formDetailsObj?.finishingImageURL) {
            setDisplayImageURL_finish(formDetailsObj.finishingImageURL);
        }

        // Send to data loading (common for both)
        if (formDetailsObj?.sentTo) {
            const findMatch = FormAnnouncementsList?.find(
                (obj) => obj?.id === formDetailsObj?.sentTo
            );
            if (findMatch) {
                setSendTo(findMatch);
            }
        }

        if (formDetailsObj?.sentTo === DEVICES.id) {
            setSelectedItems(formDetailsObj?.devices?.map?.((obj) => obj?.deviceId));
        }

        if (formDetailsObj?.sentTo === POLICY_GROUP.id) {
            setSelectedItems(
                formDetailsObj?.group?.map?.((obj) => obj?.policyGroupId)
            );
        }

        if (isTemplate) {
            // Template specific data loading
            if (formDetailsObj?.templateType) {
                setTemplateType(formDetailsObj.templateType);
            }

            if (formDetailsObj?.startTime) {
                const time = new Date(formDetailsObj.startTime);
                const hour = time.getHours();
                const minute = time.getMinutes();

                // Convert 24-hour to 12-hour format
                if (hour === 0) {
                    setSelectedHour(12);
                    setSelectedPeriod("AM");
                } else if (hour <= 12) {
                    setSelectedHour(hour);
                    setSelectedPeriod("AM");
                } else {
                    setSelectedHour(hour - 12);
                    setSelectedPeriod("PM");
                }
                setSelectedMinute(minute);
            }

            if (formDetailsObj?.duration) {
                // Convert minutes back to days and hours
                const totalMinutes = parseInt(formDetailsObj.duration);
                const days = Math.floor(totalMinutes / (24 * 60));
                const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
                setDuration({ days, hours });
            }

            if (formDetailsObj?.RecurringParam || formDetailsObj?.recurringParam) {
                try {
                    const recurringData = typeof (formDetailsObj?.RecurringParam || formDetailsObj?.recurringParam) === 'string'
                        ? JSON.parse(formDetailsObj?.RecurringParam || formDetailsObj?.recurringParam)
                        : (formDetailsObj?.RecurringParam || formDetailsObj?.recurringParam);

                    if (recurringData?.days && Array.isArray(recurringData.days) && recurringData.days.length > 0) {
                        setActiveDays(recurringData.days);
                    } else {
                        // If no active days or empty array, default to today
                        setActiveDays([new Date().getDay()]);
                    }
                } catch (error) {
                    console.error("Error parsing recurring param:", error);
                    // If parsing fails, also default to today
                    setActiveDays([new Date().getDay()]);
                }
            } else {
                // If no RecurringParam data, default to today
                setActiveDays([new Date().getDay()]);
            }
        } else {
            // Regular form data loading
            if (formDetailsObj?.startTime) {
                setStartTime(new Date(formDetailsObj.startTime));
            }

            if (formDetailsObj?.endTime) {
                setEndTime(new Date(formDetailsObj.endTime));
            }
        }

        checkAllowPublush();
    }, [formDetailsObj, isTemplate]);

    const fetchPolicyGroupsData = async () => {
        try {
            const response = await fetchPolicyGroups(org.id);
            if (response.success) {
                setGroups(response.data);
            } else {
                console.error("Failed to fetch policy groups:", response.error);
            }
        } catch (error) {
            console.error("Failed to fetch policy groups:", error);
        }
    };

    const fetchOrganizationDevicesData = async () => {
        try {
            const response = await fetchOrganizationDevices(org.code, false);
            if (response.success) {
                setDevices(response.data);
            } else {
                console.error("Failed to fetch devices:", response.error);
            }
        } catch (error) {
            console.error("Failed to fetch devices:", error);
        }
    };

    useEffect(() => {
        fetchPolicyGroupsData();
        fetchOrganizationDevicesData();
    }, []);

    useEffect(() => {
        if (selectedItems.length === filteredItems?.length) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    }, [selectedItems, filteredItems]);

    const validateForm = () => {
        const validationErrors = {};

        // Common validation
        if (!sendTo) {
            validationErrors.sendTo = "Please select a recipient.";
        }

        if (sendTo?.id === POLICY_GROUP.id || sendTo?.id === DEVICES?.id) {
            if (displaySelectedItems.trim().length === 0) {
                validationErrors.selection = `Please select at least one ${sendTo?.id === POLICY_GROUP.id ? "group" : "device"}.`;
            }
        }

        if (isTemplate) {
            // Template specific validation
            if (!templateType) {
                validationErrors.templateType = "Please select a template type.";
            }

            if (activeDays.length === 0) {
                validationErrors.activeDays = "Please select at least one active day.";
            }

            if (duration.days === 0 && duration.hours === 0) {
                validationErrors.duration = "Duration must be at least 1 hour.";
            }
        } else {
            // Regular form validation
            if (endTime <= startTime) {
                validationErrors.date = "End time must be after start time.";
            }
        }

        setErrors(validationErrors);
        setIsFormValid(Object.keys(validationErrors).length === 0);
    };

    const checkAllowPublush = () => {
        setallowPublish(false)
        if (startTime && endTime && formDetailsObj.hasQuestions) {
            if (sendTo.id === "every_one" || selectedItems.length > 0) {
                setallowPublish(true)
            }
        }
    }

    useEffect(() => {
        if (formDirty_Settings) {
            validateForm();
        }

        checkAllowPublush();
    }, [startTime, endTime, sendTo, selectedItems, displayTitleText, FinishingTitleText, templateType, activeDays, duration, selectedHour, selectedMinute, selectedPeriod, formDirty_Settings, isTemplate]);

    // Template specific handlers
    const handleTemplateTypeChange = (e) => {
        const val = e.target.value;
        if (!formDirty_Settings) setformDirty_Settings(true);
        setTemplateType(val);
        // Only set default if no active days are currently selected
        if (!activeDays || activeDays.length === 0) {
            setActiveDays([new Date().getDay()]);
        }
    };

    const handleTimeChange = (type, value) => {
        if (!formDirty_Settings) setformDirty_Settings(true);
        if (type === "hour") {
            setSelectedHour(parseInt(value));
        } else if (type === "minute") {
            setSelectedMinute(parseInt(value));
        } else if (type === "period") {
            setSelectedPeriod(value);
        }
    };

    const handleDurationChange = (type, value) => {
        if (!formDirty_Settings) setformDirty_Settings(true);
        const numValue = Math.max(0, parseInt(value) || 0);
        setDuration(prev => ({
            ...prev,
            [type]: numValue
        }));
    };

    const handleActiveDayToggle = (dayId) => {
        if (!formDirty_Settings) setformDirty_Settings(true);
        setActiveDays(prev =>
            prev.includes(dayId)
                ? prev.filter(id => id !== dayId)
                : [...prev, dayId]
        );
    };

    // Regular form handlers
    const handleDateChange = (date, type) => {
        if (!formDirty_Settings) setformDirty_Settings(true);
        if (type === "startTime") {
            setStartTime(date);
        } else if (type === "endTime") {
            setEndTime(date);
        }
    };

    const handleSendToSelect = async (announcement) => {
        if (!formDirty_Settings) setformDirty_Settings(true);

        if (sendTo?.id !== announcement?.id) {
            setSelectedItems([]);
            setSearchQuery("");
            setSelectAll(false);
        }

        setSendTo(announcement);

        if (announcement?.id === EVERY_ONE.id) {
            setItemPicker(false);
        } else if (announcement?.id === POLICY_GROUP.id || announcement?.id === DEVICES?.id) {

            setItemPicker(true);
            setIsLoadingModalData(true);

            try {
                if (announcement?.id === POLICY_GROUP.id) {
                    await fetchPolicyGroupsData();
                } else if (announcement?.id === DEVICES?.id) {
                    await fetchOrganizationDevicesData();
                }
            } catch (error) {
                console.error("Error loading data:", error);
            } finally {
                setIsLoadingModalData(false);
            }
        }
    };

    const handleSelectAll = () => {
        setformDirty_Settings(true);
        setSelectAll(!selectAll);
        if (!selectAll) {
            setSelectedItems(filteredItems.map((item) => item.id));
        } else {
            setSelectedItems([]);
        }
    };

    const handleCancel = () => {
        setItemPicker(false);
        setSearchQuery("");
        setSelectAll(false);
        setSelectedItems([]);
    };

    const handleItemSelect = (itemId) => {
        if (!formDirty_Settings) setformDirty_Settings(true);

        setSelectedItems((prevSelectedItems) =>
            prevSelectedItems.includes(itemId)
                ? prevSelectedItems.filter((id) => id !== itemId)
                : [...prevSelectedItems, itemId]
        );
    };

    const handleConfirm = () => {
        setItemPicker(false);
    };

    // Common handlers
    const handleDescriptionChange = (event) => {
        const value = event.target.value;
        setformDirty_Settings(true);
        setDisplayTitleText(value);
    };

    const resetDisplayImage = () => {
        setDisplayImageURL(deviceProfile);
        setDisplaySelectedFile(null);
    };

    const resetDisplayImage_finish = () => {
        setDisplayImageURL_finish(deviceProfile);
        setDisplaySelectedFile_finish(null);
    };

    const handleImageChange = () => {
        fileInputRef.current.click();
    };

    const handleImageChange_finish = () => {
        fileInputRef_finish.current.click();
    };

    const displayImageChangeHandler = (e) => {
        const file = e.target.files[0];
        if (file) {
            const allowedTypes = ["image/jpeg", "image/png"];
            const maxSizeInBytes = 15 * 1024 * 1024; // 15 MB

            if (!allowedTypes.includes(file.type)) {
                toast.error("Only PNG and JPG files are allowed.");
                return;
            }

            if (file.size > maxSizeInBytes) {
                toast.error("Image size must be less than 15 MB.");
                return;
            }

            setformDirty_Settings(true);
            setDisplaySelectedFile(file);
            setDisplayImageURL(URL.createObjectURL(file));
        }
    };

    const displayImageChangeHandler_finish = (e) => {
        const file = e.target.files[0];
        if (file) {
            const allowedTypes = ["image/jpeg", "image/png"];
            const maxSizeInBytes = 15 * 1024 * 1024; // 15 MB

            if (!allowedTypes.includes(file.type)) {
                toast.error("Only PNG and JPG files are allowed.");
                return;
            }

            if (file.size > maxSizeInBytes) {
                toast.error("Image size must be less than 15 MB.");
                return;
            }

            setformDirty_Settings(true);
            setDisplaySelectedFile_finish(file);
            setDisplayImageURL_finish(URL.createObjectURL(file));
        }
    };

    const updateFormDetailsHandler = async (payload, form_status) => {
        const response = await updateFormDetails(payload);
        await refetchFormDetails();
        if (response?.success) {
            if (isTemplate) {
                toast.success("Template updated successfully");
            }
            else {
                if (form_status === "published") {
                    toast.success(`Form published successfully`);
                }
                else if (form_status === "unpublish") {
                    toast.success(`Form unpublished successfully`);
                }
                else {
                    toast.success("Form updated successfully");
                }
            }
        }
    };

    const onApplyClickDialogHandler = (form_status, checkvalidForm) => {
        if (!isFormValid && checkvalidForm) return;

        setopenUnPublishpopup(false);
        setFormStatus(form_status);
        if (isTemplate) {
            onApplyClick(form_status);
        }
        else {
            if (form_status === "unpublish" || form_status === "draft") {
                onApplyClick(form_status);
            }
            else {
                setIsAnnouncementConfirmModal(true);
            }
        }
    };

    const onApplyClick = async (form_status) => {
        const storedUserInfo = localStorage.getItem("userInfo") ?? "{}";
        const parsedUserInfo = JSON.parse(storedUserInfo);

        let payload = {
            id: formDetailsObj?.id,
            userId: parsedUserInfo?.userId,
            formName: formDetailsObj?.formName,
            description: displayTitleText,
            finishingDesc: FinishingTitleText,
            formType: formDetailsObj?.formType,
            displayType: formDetailsObj?.displayType,
            sentTo: sendTo?.id,
            formStatus: form_status === "unpublish" ? 'draft' : form_status
        };

        // Add devices/groups selection
        if (sendTo?.id === DEVICES?.id) {
            payload.devices = selectedItems;
        }

        if (sendTo?.id === POLICY_GROUP.id) {
            payload.policyGroupIds = selectedItems;
        }

        if (isTemplate) {
            // Template specific payload
            payload.templateType = templateType;

            if (templateType !== "worker_check_in") {
                // Convert 12-hour format to 24-hour and create Date
                let hour24 = selectedHour;
                if (selectedPeriod === "PM" && selectedHour !== 12) {
                    hour24 = selectedHour + 12;
                } else if (selectedPeriod === "AM" && selectedHour === 12) {
                    hour24 = 0;
                }

                const timeDate = new Date();
                timeDate.setHours(hour24, selectedMinute, 0, 0);
                payload.startTime_UTC = timeDate.toISOString();
                payload.startTime = moment(timeDate).format('YYYY-MM-DDTHH:mm');

                // Convert to minutes and send as string
                const totalMinutes = (duration.days * 24 * 60) + (duration.hours * 60);
                payload.duration = totalMinutes.toString(); // Convert to string
                payload.recurringParam = JSON.stringify({ days: activeDays });
            }
        } else {
            // Regular form payload
            payload.startTime = startTime && moment(startTime).format('YYYY-MM-DDTHH:mm');
            payload.endTime = endTime && moment(endTime).format('YYYY-MM-DDTHH:mm');
        }

        if (displaySelectedFile) {
            const response = await updateFormImage(formDetailsObj?.id, displaySelectedFile, false);

            if (response.success) {
                setDisplayImageURL(response.data.imageURL);
            }
        }

        if (displaySelectedFile_finish) {
            const response = await updateFormImage(formDetailsObj?.id, displaySelectedFile_finish, true);
            if (response.success) {
                setDisplayImageURL_finish(response.data.finishingImageURL);
            }
        }

        await updateFormDetailsHandler(payload, form_status);
        setformDirty_Settings(false);
    };

    const onCloseAnnouncementHandler = () => {
        setIsAnnouncementConfirmModal(false);
    };

    const onCancelAnnouncementHandler = () => {
        setIsAnnouncementConfirmModal(false);
    };

    const onOkAnnouncementHandler = () => {
        setIsAnnouncementConfirmModal(false);
        onApplyClick(formStatus);
    };

    useEffect(() => {
        DisableSendUpdates();
    }, [formDirty_Settings, isFormValid, startTime, endTime]);

    const [disableSendUpdates, setdisableSendUpdates] = useState(false);
    const DisableSendUpdates = () => {
        setdisableSendUpdates(false);

        if (!isTemplate && formDetailsObj?.formStatus === 'published') {
            if (!hasValue(startTime) || !hasValue(endTime)) {
                setdisableSendUpdates(true);
            }
            else if (!isFormValid) {
                setdisableSendUpdates(true);
            }
        }
    }

    return (
        <div className="table-wrap padding_infor_info">
            <div className="form-group">
                {/* Display title */}
                <label style={{ color: "black", fontWeight: "bold" }}>Display title</label>
                <textarea
                    className="form-control"
                    placeholder="Write your display title here..."
                    rows="2"
                    value={displayTitleText}
                    onChange={handleDescriptionChange}
                />

                {/* Display Image */}
                <label className="margin_top_30" style={{ color: "black", fontWeight: "bold" }} id="Recipients">Display Image</label>
                <div className="d-flex flex-column align-self-start">
                    <button
                        className="btn btn-secondary rounded-circle position-absolute top-0 end-0 p-2 mr-2 mt-2 align-self-end"
                        style={{ cursor: "pointer", lineHeight: "0.5" }}
                        onClick={handleImageChange}
                    >
                        <i className="fa fa-pencil text-white" aria-hidden="true"></i>
                    </button>
                    <input
                        type="file"
                        accept="image/*"
                        className="d-none"
                        ref={fileInputRef}
                        onChange={displayImageChangeHandler}
                    />
                    <img
                        src={displayImageURL}
                        alt="Preview"
                        style={{
                            width: "auto",
                            height: "auto",
                            maxHeight: "150px",
                            objectFit: "contain",
                        }}
                    />
                    <button
                        onClick={resetDisplayImage}
                        style={{
                            marginTop: "10px",
                            fontSize: "12px",
                            color: "blue",
                            borderWidth: 0,
                            background: "transparent",
                            cursor: "pointer",
                        }}
                    >
                        Reset Image
                    </button>
                </div>

                {/* Send to (common for both form and template) */}
                <label className="margin_top_30" style={{ color: "black", fontWeight: "bold" }}>Send to</label>
                <div>
                    {FormAnnouncementsList.map((announcement) => (
                        <label
                            key={announcement.id}
                            htmlFor={announcement.id}
                            style={{ marginRight: 70 }}
                            onClick={() => handleSendToSelect(announcement)}
                        >
                            <input
                                type="radio"
                                readOnly={true}
                                id={announcement.name}
                                style={{ marginRight: 5, accentColor: "#007bff" }}
                                value={announcement.name}
                                checked={sendTo?.id === announcement.id}
                            />
                            {announcement.name}
                        </label>
                    ))}
                </div>
                {formDirty_Settings && errors.sendTo && (
                    <span style={{ color: "red", fontSize: "14px" }}>
                        {errors.sendTo}
                    </span>
                )}

                {(sendTo?.id === DEVICES?.id || sendTo?.id === POLICY_GROUP.id) && (
                    <div className="form-group" style={{ marginTop: 25 }}>
                        <label style={{ fontWeight: 400, fontSize: 16 }}>
                            Selected {sendTo?.id === POLICY_GROUP.id ? "groups" : "devices"}:
                        </label>
                        <div>{displaySelectedItems}</div>
                        {formDirty_Settings && errors.selection && (
                            <span style={{ color: "red", fontSize: "14px" }}>
                                {errors.selection}
                            </span>
                        )}
                    </div>
                )}

                {/* Template vs Form specific sections */}
                {isTemplate ? (
                    <>
                        {/* Template: Create a Form from this Template */}
                        <label className="margin_top_30" style={{ color: "black", fontWeight: "bold" }}>Create a Form from this Template</label>
                        <div>
                            {templateOptions.map((option) => (
                                <label
                                    key={option.value}
                                    style={{ marginRight: 70, display: "block", marginBottom: 10 }}
                                >
                                    <input
                                        type="radio"
                                        name="templateType"
                                        value={option.value}
                                        checked={templateType === option.value}
                                        onChange={handleTemplateTypeChange}
                                        style={{ marginRight: 8, accentColor: "#007bff" }}
                                    />
                                    {option.label}
                                </label>
                            ))}
                        </div>
                        {formDirty_Settings && errors.templateType && (
                            <span style={{ color: "red", fontSize: "14px" }}>
                                {errors.templateType}
                            </span>
                        )}

                        {templateType === "worker_check_in" ? null :
                            <>
                                {/* Template: Time with three dropdowns */}
                                <div className="form-group margin_top_30">
                                    <label style={{ color: "black", fontWeight: "bold" }}>Time:</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                                        <select
                                            value={selectedHour}
                                            onChange={(e) => handleTimeChange("hour", e.target.value)}
                                            className="form-control"
                                            style={{ width: "80px" }}
                                        >
                                            {hours.map(hour => (
                                                <option key={hour} value={hour}>{hour.toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                        <span>:</span>
                                        <select
                                            value={selectedMinute}
                                            onChange={(e) => handleTimeChange("minute", e.target.value)}
                                            className="form-control"
                                            style={{ width: "80px" }}
                                        >
                                            {minutes.map(minute => (
                                                <option key={minute} value={minute}>{minute.toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                        <select
                                            value={selectedPeriod}
                                            onChange={(e) => handleTimeChange("period", e.target.value)}
                                            className="form-control"
                                            style={{ width: "80px" }}
                                        >
                                            {periods.map(period => (
                                                <option key={period} value={period}>{period}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Template: Duration */}
                                <div className="form-group margin_top_30">
                                    <label style={{ color: "black", fontWeight: "bold" }}>Duration:</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <input
                                            type="number"
                                            min="0"
                                            max="30"
                                            value={duration.days}
                                            onChange={(e) => handleDurationChange("days", e.target.value)}
                                            className="form-control"
                                            style={{ width: "80px" }}
                                        />
                                        <span>days</span>
                                        <input
                                            type="number"
                                            min="0"
                                            max="23"
                                            value={duration.hours}
                                            onChange={(e) => handleDurationChange("hours", e.target.value)}
                                            className="form-control"
                                            style={{ width: "80px" }}
                                        />
                                        <span>hours</span>
                                    </div>
                                    {formDirty_Settings && errors.duration && (
                                        <span style={{ color: "red", fontSize: "14px" }}>
                                            {errors.duration}
                                        </span>
                                    )}
                                </div>

                                {/* Template: Active Days (always show for templates) */}
                                <div className="form-group margin_top_30">
                                    <label style={{ color: "black", fontWeight: "bold" }}>Active Days:</label>
                                    <div style={{ display: "flex", gap: "15px", flexWrap: "wrap", marginTop: "10px" }}>
                                        {daysOfWeek.map((day) => (
                                            <label key={day.id} style={{ display: "flex", alignItems: "center", cursor: "pointer", minWidth: "80px" }} >
                                                <input
                                                    type="checkbox"
                                                    checked={activeDays.includes(day.id)}
                                                    onChange={() => handleActiveDayToggle(day.id)}
                                                    style={{ marginRight: "5px" }}
                                                />
                                                {day.short}
                                            </label>
                                        ))}
                                    </div>
                                    {formDirty_Settings && errors.activeDays && (
                                        <span style={{ color: "red", fontSize: "14px" }}>
                                            {errors.activeDays}
                                        </span>
                                    )}
                                </div>
                            </>
                        }
                    </>
                ) : (
                    <>
                        {/* Regular Form: Start and End Time */}
                        <div className="form-group margin_top_30" style={{ width: "25%" }}>
                            <label htmlFor="schedule-start-date">Start Time:</label>
                            <DatePicker id="startTime"
                                selected={startTime}
                                onChange={(date) => handleDateChange(date, "startTime")}
                                showTimeSelect
                                dateFormat="yyyy-MM-dd HH:mm"
                                timeFormat="HH:mm"
                                className="form-control"
                                style={{ width: "200px" }}
                                minDate={new Date()}
                            />
                        </div>
                        <div className="form-group" style={{ width: "25%" }}>
                            <label htmlFor="schedule-end-date">End Time:</label>
                            <DatePicker id="endTime"
                                selected={endTime}
                                onChange={(date) => handleDateChange(date, "endTime")}
                                showTimeSelect
                                dateFormat="yyyy-MM-dd HH:mm"
                                timeFormat="HH:mm"
                                className="form-control"
                                style={{ width: "200px", marginLeft: "8px" }}
                                minDate={startTime}
                                maxDate={startTime && new Date(startTime.getTime() + 365 * 24 * 60 * 60 * 1000)}
                            />
                            {formDirty_Settings && errors.date && (
                                <span
                                    style={{
                                        color: "red",
                                        fontSize: "14px",
                                        display: "block",
                                        marginTop: "10px",
                                    }}
                                >
                                    {errors.date}
                                </span>
                            )}
                        </div>
                    </>
                )}

                {/* Common: Finishing page section */}
                <label className="margin_top_30" style={{ color: "black", fontWeight: "bold" }}>Finishing page title</label>
                <textarea
                    className="form-control"
                    placeholder="Write your finishing text here..."
                    rows="2"
                    value={FinishingTitleText}
                    onChange={(e) => {
                        setformDirty_Settings(true);
                        setFinishingTitleText(e.target.value);
                    }}
                />

                <label className="margin_top_30" style={{ color: "black", fontWeight: "bold" }}>Finishing page Image</label>
                <div className="d-flex flex-column align-self-start">
                    <button
                        className="btn btn-secondary rounded-circle position-absolute top-0 end-0 p-2 mr-2 mt-2 align-self-end"
                        style={{ cursor: "pointer", lineHeight: "0.5" }}
                        onClick={handleImageChange_finish}
                    >
                        <i className="fa fa-pencil text-white" aria-hidden="true"></i>
                    </button>
                    <input
                        type="file"
                        accept="image/*"
                        className="d-none"
                        ref={fileInputRef_finish}
                        onChange={displayImageChangeHandler_finish}
                    />
                    <img
                        src={displayImageURL_finish}
                        alt="Preview"
                        style={{
                            width: "auto",
                            height: "auto",
                            maxHeight: "150px",
                            objectFit: "contain",
                        }}
                    />
                    <button
                        onClick={resetDisplayImage_finish}
                        style={{
                            marginTop: "10px",
                            fontSize: "12px",
                            color: "blue",
                            borderWidth: 0,
                            background: "transparent",
                            cursor: "pointer",
                        }}
                    >
                        Reset Image
                    </button>
                </div>

                <div className="form-group" style={{ display: "inline" }}>
                    <button type="button" className={formDetailsObj?.formStatus === 'published' ? "btn cur-p btn-primary" : "btn cur-p btn-outline-dark"} onClick={(e) => { e.preventDefault(); onApplyClickDialogHandler(isTemplate ? '' : formDetailsObj?.formStatus !== 'published' ? 'draft' : formDetailsObj.formStatus, true) }}
                        style={{ alignSelf: "flex-start", marginRight: "30px", paddingLeft: "30px", paddingRight: "30px", marginTop: "30px", cursor: isFormValid ? "pointer" : "not-allowed", opacity: !disableSendUpdates ? 1 : 0.6, }}
                        disabled={disableSendUpdates} >
                        {!isTemplate ? formDetailsObj?.formStatus === 'published' ? "Send updates" : "Save" : "Save"}
                    </button>

                    {formDetailsObj?.formStatus !== 'published' && !isTemplate &&
                        <button type="button" className={allowPublish ? "btn cur-p btn-primary" : "btn cur-p btn-primary"} disabled={!allowPublish}
                            onClick={(e) => { e.preventDefault(); onApplyClickDialogHandler('published', false); }}
                            style={{ alignSelf: "flex-start", paddingLeft: "30px", paddingRight: "30px", marginTop: "30px", opacity: allowPublish ? 1 : 0.6 }} >
                            Publish
                        </button>
                    }

                    {formDetailsObj?.formStatus === 'published' && !isTemplate &&
                        <button type="button" className="btn cur-p btn-outline-dark"
                            onClick={(e) => { e.preventDefault(); setopenUnPublishpopup(true); }}
                            style={{ alignSelf: "flex-start", paddingLeft: "30px", paddingRight: "30px", marginTop: "30px", opacity: allowPublish ? 1 : 0.6 }} >
                            Unpublish
                        </button>
                    }
                </div>
                {formDetailsObj?.formStatus !== 'published' && !isTemplate &&
                    <>
                        {allowPublish ?
                            <span>
                                <i class="fa fa-check-circle-o" aria-hidden="true"></i>  Form is ready to publish.
                            </span>
                            :
                            <span>

                                The following fields must be complete before publishing: <br />
                                {!(sendTo.id === "every_one" || selectedItems.length > 0) && <><u><a style={{ cursor: "pointer" }} href="#Recipients">Recipients</a></u>  </>}
                                {!startTime && <><u><a style={{ cursor: "pointer" }} onClick={(e) => document.getElementById('startTime').focus()}>Start Date</a></u>  </>}
                                {!endTime && <><u><a style={{ cursor: "pointer" }} onClick={(e) => document.getElementById('endTime').focus()}>End Date</a></u>  </>}
                                {!(formDetailsObj !== null && formDetailsObj.hasQuestions) && <> <u><a style={{ cursor: "pointer" }} onClick={(e) => handleTabClick("Questions")}>At least one question</a></u></>}
                            </span>
                        }
                    </>
                }
                {formDetailsObj?.formStatus === 'published' && !isTemplate &&
                    <>
                        <span>
                            Form is currently visible to end-users. To make it invisible, select "Unpublish".
                        </span>
                    </>
                }
            </div>

            {/* Modals */}
            <SendToModal
                visible={itemPicker}
                sendTo={sendTo}
                title={sendTo?.id === POLICY_GROUP.id ? "Groups" : "Devices"}
                searchPlaceholderText={
                    sendTo?.id === POLICY_GROUP.id ? "groups" : "devices"
                }
                searchQuery={searchQuery}
                filteredItems={filteredItems}
                selectedItems={selectedItems}
                selectAll={selectAll}
                tableTitle={`Select ${sendTo?.id === POLICY_GROUP.id ? "Groups" : "Devices"
                    }`}
                handleCancel={handleCancel}
                setSearchQuery={setSearchQuery}
                handleSelectAll={handleSelectAll}
                handleItemSelect={handleItemSelect}
                handleConfirm={handleConfirm}
                isLoading={isLoadingModalData}
            />
            <AnnouncementModal UpdatedformStatus={formStatus} formStatus={formDetailsObj?.formStatus}
                isTemplate={isTemplate}
                count={selectedItems?.length}
                target={sendTo} startTime={startTime}
                visible={isAnnouncementConfirmModal}
                onClose={onCloseAnnouncementHandler}
                onCancel={onCancelAnnouncementHandler}
                onOkPress={onOkAnnouncementHandler}
            />

            {openUnPublishpopup &&
                <>
                    <ModalWrapper>
                        <div class="modal-header">
                            <h1 class="modal-title">Unpublish Form</h1>
                            <button className="close-button" style={{ alignSelf: "flex-end" }} onClick={(e) => { e.preventDefault(); setopenUnPublishpopup(false) }} > &times; </button>
                        </div>
                        <div className="modal-body" style={{ textAlign: "center" }}>
                            <h4 className="p-0 m-0">
                                Are you sure you want to unpublish this form? This will remove it from CareWindow devices.</h4>
                            <br />
                            <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                                <button className="btn bg-white border border-dark text-dark px-4 py-2" onClick={(e) => { e.preventDefault(); setopenUnPublishpopup(false) }} > Cancel </button>
                                <button className="btn btn-dark" onClick={(e) => { e.preventDefault(); onApplyClickDialogHandler('unpublish', false) }} > OK </button>
                            </div>
                        </div>
                    </ModalWrapper>
                </>

            }
        </div>
    );
};

export default memo(Settings);